import Dh_main from "./main/Dh_main";

export default function HomeDashboard (){
    return (
        <>
        <div className="mtCGfreeUniv">
            <Dh_main/>
        </div>
        </>
    )
}